import { CarbonIconType } from "@carbon/icons-react";
import React from "react";

interface DocumentsContainerProps {
  icon: CarbonIconType;
  title: string;
  children: React.ReactNode;
}

export const DocumentsContainer = ({ icon: Icon, title, children }: DocumentsContainerProps) => {
  return (
    <div className="rounded bg-white text-gray-550 shadow">
      <div className="flex py-[20px] items-center gap-2 uppercase pl-[32px] borber border-b border-solid border-gray-100">
        <Icon size={18} />
        <p className="text-sm">{title}</p>
      </div>
      <div className="p-[32px]">{children}</div>
    </div>
  );
};
